import { observer } from "mobx-react-lite";
import { FunctionComponent } from "react";

import { Stack, TopBarDefaultHeader } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { routes } from "@libs/routing/routes.ts";
import { ClaimPivotTabs } from "@modules/acc/screens/shared-components/ClaimPivotTabs.tsx";
import { useStores } from "@stores/hooks/useStores.ts";
import { FormSubmitButtons } from "@ui-components/form/submission-form/FormSubmitButtons.tsx";
import { When } from "@ui-components/withPerm.tsx";

export const ClaimDischargeFormHeader: FunctionComponent = observer(() => {
  const { routing } = useStores();

  const rightContainer = (
    <When permission={Permission.ClaimWrite}>
      <Stack horizontal tokens={{ childrenGap: 8 }}>
        <FormSubmitButtons
          styles={{
            root: {
              marginTop: 0,
              borderTopColor: "none",
              backgroundColor: "inherit",
              paddingTop: 0
            }
          }}
          hideButtonsSeparator
          submitButtonProps={{
            iconProps: { hidden: true },
            text: "Save & close"
          }}
          disableSubmitOnPristine
          onCancel={() => {
            routing.goToFromState(routes.claims.basePath.pattern);
          }}
        />
      </Stack>
    </When>
  );

  return (
    <TopBarDefaultHeader
      hideBackButton
      leftContainer={<ClaimPivotTabs />}
      leftContainerStyles={{ root: { paddingLeft: 0 } }}
      rightContainer={rightContainer}
    />
  );
});
